import toggle from '../helpers/toggleArrayElement';

// The possible filters. This file shouldn't need to be customized - filters that aren't displayed will just not be set.
const FULL_TEXT_SEARCH_CHANGED = 'FULL_TEXT_SEARCH_CHANGED';
const VINTAGE_TOGGLED = 'VINTAGE_TOGGLED';
const GRAPE_VARIETY_TOGGLED = 'GRAPE_VARIETY_TOGGLED';
const MAIN_VARIETY_TOGGLED = 'MAIN_VARIETY_TOGGLED';
const SOIL_TYPE_TOGGLED = 'SOIL_TYPE_TOGGLED';
const MAIN_SOIL_TYPE_TOGGLED = 'MAIN_SOIL_TYPE_TOGGLED';
const NAME_TOGGLED = 'NAME_TOGGLED';
const PRODUCT_TYPE_TOGGLED = 'PRODUCT_TYPE_TOGGLED';
const BLEND_TYPE_TOGGLED = 'BLEND_TYPE_TOGGLED';
const SOIL_BLEND_TYPE_TOGGLED = 'SOIL_BLEND_TYPE_TOGGLED';
const COUNTRY_TOGGLED = 'COUNTRY_TOGGLED';
const REGION_TOGGLED = 'REGION_TOGGLED';
const SUBREGION_TOGGLED = 'SUBREGION_TOGGLED';
const REGION_NAME_TOGGLED = 'REGION_NAME_TOGGLED';
const DENOMINATION_TOGGLED = 'DENOMINATION_TOGGLED';
const AWARD_TOGGLED = 'AWARD_TOGGLED';
const CHARACTERISTICS_TOGGLED = 'CHARACTERISTICS_TOGGLED';
const CLASSIFICATION_TOGGLED = 'CLASSIFICATION_TOGGLED';
const DESIGNATION_TOGGLED = 'DESIGNATION_TOGGLED';
const PRICE_CHANGED = 'PRICE_CHANGED';
const PRICE_RANGE_TOGGLED = 'PRICE_RANGE_TOGGLED';
const FILTERS_CLEARED = 'FILTERS_CLEARED';
const CLOSURE_TYPE_TOGGLED = 'CLOSURE_TYPE_TOGGLED';
const HIGHLIGHT_TOGGLED = 'HIGHLIGHT_TOGGLED';

/**
 *
 * @param {string} queryString The term to search.
 * @returns {[typeof FULL_TEXT_SEARCH_CHANGED, string]}
 */
export function searchTermChanged(queryString) {
  return [FULL_TEXT_SEARCH_CHANGED, queryString];
}

export function vintageToggled(vintage) {
  return [VINTAGE_TOGGLED, vintage];
}

export function grapeVarietyToggled(variety) {
  return [GRAPE_VARIETY_TOGGLED, variety];
}

export function mainVarietyToggled(variety) {
  return [MAIN_VARIETY_TOGGLED, variety];
}

export function soilTypeToggled(variety) {
  return [SOIL_TYPE_TOGGLED, variety];
}

export function mainSoilTypeToggled(variety) {
  return [MAIN_SOIL_TYPE_TOGGLED, variety];
}

export function nameToggled(name) {
  return [NAME_TOGGLED, name];
}

export function productTypeToggled(type) {
  return [PRODUCT_TYPE_TOGGLED, type];
}

export function blendTypeToggled(type) {
  return [BLEND_TYPE_TOGGLED, type];
}

export function soilBlendTypeToggled(type) {
  return [SOIL_BLEND_TYPE_TOGGLED, type];
}

export function awardToggled(type) {
  return [AWARD_TOGGLED, type];
}

export function countryToggled(type) {
  return [COUNTRY_TOGGLED, type];
}

export function regionToggled(type) {
  return [REGION_TOGGLED, type];
}

export function subregionToggled(type) {
  return [SUBREGION_TOGGLED, type];
}

export function regionNameToggled(type) {
  return [REGION_NAME_TOGGLED, type];
}

export function denominationToggled(type) {
  return [DENOMINATION_TOGGLED, type];
}

export function characteristicsToggled(type) {
  return [CHARACTERISTICS_TOGGLED, type];
}

export function designationToggled(type) {
  return [DESIGNATION_TOGGLED, type];
}

export function classificationToggled(type) {
  return [CLASSIFICATION_TOGGLED, type];
}

export function priceChanged([min, max]) {
  return [PRICE_CHANGED, [min, max]];
}
export function priceRangeToggled(range) {
  return [PRICE_RANGE_TOGGLED, range];
}

export function closureTypeToggled(type) {
  return [CLOSURE_TYPE_TOGGLED, type];
}

export function highlightToggled(type) {
  return [HIGHLIGHT_TOGGLED, type];
}

export function filtersCleared() {
  return [FILTERS_CLEARED];
}

const initialFilterState = {
  searchTerm: '',
  vintages: [],
  names: [],
  awards: [],
  grapeVarieties: [],
  mainVarieties: [],
  blendTypes: [],
  soilTypes: [],
  mainSoilTypes: [],
  soilBlendTypes: [],
  productTypes: [],
  countries: [],
  regions: [],
  subregions: [],
  regionNames: [],
  denominations: [],
  characteristics: [],
  designations: [],
  classifications: [],
  price: [undefined, undefined],
  priceRanges: [],
  closureTypes: [],
  highlights: [],
};

// The complete state could be different, e.g. have the sort order or grouping in it.
export const initialState = { ...initialFilterState };

export default function reducer(state, event) {
  const [type, payload] = event;
  switch (type) {
    case FULL_TEXT_SEARCH_CHANGED: {
      return { ...state, searchTerm: payload };
    }

    case VINTAGE_TOGGLED: {
      return {
        ...state,
        vintages: toggle(state.vintages, payload),
        currentOffset: 0,
      };
    }

    case NAME_TOGGLED: {
      return {
        ...state,
        names: toggle(state.names, payload),
        currentOffset: 0,
      };
    }

    case PRODUCT_TYPE_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        productTypes: state.productTypes.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case COUNTRY_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        countries: state.countries.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case REGION_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        regions: state.regions.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case SUBREGION_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        subregions: state.subregions.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case REGION_NAME_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        regionNames: state.regionNames.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case DENOMINATION_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        denominations: state.denominations.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    /*
    This is a complex handler for grape varieties.
     */
    case BLEND_TYPE_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        blendTypes: state.blendTypes.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case GRAPE_VARIETY_TOGGLED: {
      return {
        ...state,
        grapeVarieties: toggle(state.grapeVarieties, payload),
        currentOffset: 0,
      };
    }

    case MAIN_VARIETY_TOGGLED: {
      return {
        ...state,
        mainVarieties: toggle(state.mainVarieties, payload),
        currentOffset: 0,
      };
    }

    /*
    This is a complex handler for soil types
     */
    case SOIL_BLEND_TYPE_TOGGLED: {
      // This is a single selection filter.
      return {
        ...state,
        soilBlendTypes: state.soilBlendTypes.includes(payload) ? [] : [payload],
        currentOffset: 0,
      };
    }

    case SOIL_TYPE_TOGGLED: {
      return {
        ...state,
        soilTypes: toggle(state.soilTypes, payload),
        currentOffset: 0,
      };
    }

    case MAIN_SOIL_TYPE_TOGGLED: {
      return {
        ...state,
        mainSoilTypes: toggle(state.mainSoilTypes, payload),
        currentOffset: 0,
      };
    }

    case AWARD_TOGGLED: {
      return {
        ...state,
        awards: toggle(state.awards, payload),
        currentOffset: 0,
      };
    }

    case CHARACTERISTICS_TOGGLED: {
      return {
        ...state,
        characteristics: toggle(state.characteristics, payload),
        currentOffset: 0,
      };
    }

    case DESIGNATION_TOGGLED: {
      return {
        ...state,
        designations: toggle(state.designations, payload),
        currentOffset: 0,
      };
    }

    case CLASSIFICATION_TOGGLED: {
      return {
        ...state,
        classifications: toggle(state.classifications, payload),
        currentOffset: 0,
      };
    }

    case PRICE_CHANGED: {
      return {
        ...state,
        price: payload, // [min, max]
        currentOffset: 0,
      };
    }

    case PRICE_RANGE_TOGGLED: {
      return {
        ...state,
        priceRanges: toggle(state.priceRanges, payload),
        currentOffset: 0,
      };
    }

    case CLOSURE_TYPE_TOGGLED: {
      return {
        ...state,
        closureTypes: toggle(state.closureTypes, payload),
        currentOffset: 0,
      };
    }

    case HIGHLIGHT_TOGGLED: {
      return {
        ...state,
        highlights: toggle(state.highlights, payload),
        currentOffset: 0,
      };
    }

    case FILTERS_CLEARED: {
      return {
        ...state,
        ...initialFilterState,
      };
    }

    default:
      return state;
  }
}
